import { useNavigate } from "react-router-dom";
import Button from 'devextreme-react/button';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import { useMemo } from "react";
import { CompanyDetails } from "../../../../types/CompanyDetails";
import { BusinessFlow } from "../../../../types/enums";
import { CTG_COMPANY_CODE } from "../../../../config/constants";

export default function CreateEstimateButton(props: {
    company: CompanyDetails | undefined,
    userToken: string | undefined
}) {

    const navigate = useNavigate();

    const menuItems = useMemo(() => {

        if (!props.company) {
            return [];
        }

        let result = [];
        if (props.company.businessFlowID !== BusinessFlow.CTG) {
            result.push({
                text: 'Easy Estimator',
                icon: 'Inscyth-Easy-Estimator',
                estimatorUrl: '/dealer/easy-estimator-old/new',
                openInNewWindow: false
            })
        }

        if (props.company.eeShowInPortal && !!props.company.easyEstimatorUrl) {
            result.push(
                {
                    text: 'Easy Estimator 2.0',
                    icon: 'Inscyth-Easy-Estimator',
                    estimatorUrl: props.company.easyEstimatorUrl + '?userToken=' + props.userToken,
                    openInNewWindow: true
                }
            )
        }

        // TODO: Only available in staging and in production we'll use a company setting
        // Only show the EE Pro Tool if the company or parent company is CTG, and we're in the staging environment.
        const isStagingOrLocal = ['sagesync-merged.staging.inscyth.com', 'sagesync.staging.inscyth.com', 'localhost'].includes(document?.location?.hostname?.toLowerCase());
        const isCtgCompany = props.company.companyCode === CTG_COMPANY_CODE || props.company.parentCompanyCode === CTG_COMPANY_CODE;
        if (isStagingOrLocal && isCtgCompany) {
            result.push(
                {
                    text: 'EE Pro Tool',
                    icon: 'Inscyth-EEPro',
                    estimatorUrl: '/dealer/easy-estimator/new',
                    openInNewWindow: false
                }
            )
        }

        return result;
    }, [props.company?.easyEstimatorUrl, props.userToken, props.company]);

    return (
        <>
            <Button id="create-estimate-button">
                <i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
                Create Estimate
                <i className={'dx-icon dx-icon-chevrondown'}></i>
            </Button>
            <ContextMenu
                width={165}
                items={menuItems}
                target="#create-estimate-button"
                showEvent="click"
                onItemClick={(e) => {
                    const data = e.itemData as any;

                    if (!!data.estimatorUrl) {
                        if (data.openInNewWindow) {
                            window.open(data.estimatorUrl);
                        } else {
                            navigate(data.estimatorUrl);
                        }
                    }
                }}
            >
                <Position my='left top' at='left bottom'>
                </Position>
            </ContextMenu>
        </>
    );
}
